module.exports = __webpack_public_path__ + "static/media/wave.21de2814.svg";